import type { Role, VoicePart } from '../api/types';

/** First and last name initials: "Ali Rıza Kaya" → "AK"; one-word names give one letter. */
export function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const picked = words.length > 1 ? [words[0], words[words.length - 1]] : words;
  return picked.map((w) => (w ?? '').charAt(0).toLocaleUpperCase('tr')).join('');
}

/** How a person's avatar looks: the director stands out. */
export type AvatarKind = 'director' | 'member';

export function avatarKind(roles: readonly Role[]): AvatarKind {
  return roles.includes('DIRECTOR') ? 'director' : 'member';
}

/** The avatar of a comment's author; their role shows only as the badge (Şef, or Grup Lideri with a section). */
export function commentAuthor(c: { authorRole: string; authorLeadsSection: VoicePart | null }): {
  kind: AvatarKind;
  leadsSection: VoicePart | null;
  /** True when the avatar shows no badge, so the role must be written out. */
  roleInText: boolean;
} {
  const kind: AvatarKind = c.authorRole === 'DIRECTOR' ? 'director' : 'member';
  const leadsSection = c.authorRole === 'SECTION_LEADER' ? c.authorLeadsSection : null;
  return { kind, leadsSection, roleInText: kind !== 'director' && !leadsSection };
}
